import { createAction, props } from '@ngrx/store';
import { Cart } from '@shared/models/cart';

export const updateCartItemCustomExpirationDate = createAction(
  '[Cart] Update Cart Item Custom Expiration Date',
  props<{ cart_id: string; cart_item_id: string; custom_expiration_date: string | null }>(),
);

export const updateCartItemCustomExpirationDateSuccess = createAction(
  '[Cart] Update Cart Item Custom Expiration Date Success',
  props<{ cart: Cart }>(),
);

export const updateCartItemCustomExpirationDateFailure = createAction(
  '[Cart] Update Cart Item Custom Expiration Date Failure',
  props<{ error: any }>(),
);
